"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrappedComponent = exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _TimelineConstants = require("crm_ui/BET/timeline/TimelineConstants");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _TimelinePermissions = require("crm_ui/BET/permissions/TimelinePermissions");

var _generalStore = require("general-store");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _QueuesStore = _interopRequireDefault(require("crm_data/queues/QueuesStore"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _TimelineStickyControls = _interopRequireDefault(require("crm_ui/timeline/components/config/controls/TimelineStickyControls"));

var TIMELINE_FILTER_ENGAGEMENT_TYPES = _interopRequireWildcard(require("crm_ui/timeline/helpers/TimelineFilterEngagementTypes"));

var _timelineRedesignPrefetcher = _interopRequireDefault(require("crm_ui/async/timeline/timelineRedesignPrefetcher"));

var _TimelineWithPinnedContent = _interopRequireDefault(require("crm_ui/timeline/components/config/TimelineWithPinnedContent"));

var _InteractionValidators = require("crm_ui/components/profile/interactions/common/InteractionValidators");

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _OptInsDependency = require("crm_data/optIns/OptInsDependency");

var hasForceFetched = false;
var BET_TABS = [_TimelineConstants.BET_RENEWAL_SUMMARY_TAB, _TimelineConstants.BET_CUSTOMER_SUMMARY_TAB];
var propTypes = {
  objectType: _ProfileObjectTypesType.default.isRequired,
  subjectId: _propTypes.default.string.isRequired,
  subject: _SubjectType.default,
  hasCommunicatePermissions: _propTypes.default.bool,
  isUngatedForActionsRedesign: _propTypes.default.bool,
  isUngatedForStickyControls: _propTypes.default.bool,
  isOptedInToActionsRedesign: _propTypes.default.bool
};
var dependencies = {
  subject: _SubjectDependency.default,
  isUngatedForStickyControls: {
    stores: [_IsUngatedStore.default],
    deref: function deref() {
      return _IsUngatedStore.default.get('CRM:StickyTimelineHeaders');
    }
  },
  isUngatedForActionsRedesign: {
    stores: [_IsUngatedStore.default],
    deref: function deref() {
      return _IsUngatedStore.default.get('CRM:RecordActions');
    }
  },
  isOptedInToActionsRedesign: (0, _OptInsDependency.isOptedInDependency)('record-actions-redesign')
};

var ProfileTimelineTabsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ProfileTimelineTabsContainer, _PureComponent);

  function ProfileTimelineTabsContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProfileTimelineTabsContainer);
    var objectType = props.objectType,
        subject = props.subject;
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ProfileTimelineTabsContainer).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      selected: _this.getDefaultTabType({
        objectType: objectType,
        subject: subject
      })
    };
    _this.profileStartTime = performance.now();
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(ProfileTimelineTabsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      (0, _timelineRedesignPrefetcher.default)();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if ((!this.props.subject || !this.props.objectType) && newProps.subject && newProps.objectType) {
        var subject = newProps.subject,
            objectType = newProps.objectType;
        this.setState({
          selected: this.getDefaultTabType({
            objectType: objectType,
            subject: subject
          })
        });
      }
    }
  }, {
    key: "getDefaultTabType",
    value: function getDefaultTabType(_ref) {
      var objectType = _ref.objectType,
          subject = _ref.subject;

      if ((0, _TimelinePermissions.canRenderRenewalSummaryTab)({
        objectType: objectType,
        subject: subject
      })) {
        return _TimelineConstants.BET_RENEWAL_SUMMARY_TAB;
      }

      if ((0, _TimelinePermissions.canRenderCustomerSummaryTab)({
        objectType: objectType,
        subject: subject
      })) {
        return _TimelineConstants.BET_CUSTOMER_SUMMARY_TAB;
      }

      return TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_ACTIVITY;
    }
  }, {
    key: "handleTabClick",
    value: function handleTabClick(type) {
      this.setState({
        selected: type
      });
    }
  }, {
    key: "handleRefreshQueuesData",
    value: function handleRefreshQueuesData() {
      if (!(0, _InteractionValidators.userCanViewQueues)()) {
        return false;
      }

      _QueuesStore.default.get({
        forceFetch: hasForceFetched
      });

      hasForceFetched = true;
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var selected = this.state.selected;
      var _this$props = this.props,
          objectType = _this$props.objectType,
          subject = _this$props.subject,
          subjectId = _this$props.subjectId,
          hasCommunicatePermissions = _this$props.hasCommunicatePermissions;
      var defaultSelected = this.getDefaultTabType({
        subject: this.props.subject,
        objectType: objectType
      });
      var activityTabIsSelected = selected === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_ACTIVITY;
      var betTabIsSelected = BET_TABS.includes(selected);
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_TimelineStickyControls.default, {
        activityTabIsSelected: activityTabIsSelected,
        betTabIsSelected: betTabIsSelected,
        defaultSelectedTab: defaultSelected,
        isUngatedForActionsRedesign: this.props.isUngatedForActionsRedesign,
        isUngatedForStickyControls: this.props.isUngatedForStickyControls,
        isOptedInToActionsRedesign: this.props.isOptedInToActionsRedesign,
        onTabClick: this.handleTabClick,
        selectedTab: selected,
        subject: subject,
        hasCommunicatePermissions: hasCommunicatePermissions
      }), _react.default.createElement("div", {
        className: "p-x-8"
      }, _react.default.createElement(_TimelineWithPinnedContent.default, {
        activityTabIsSelected: activityTabIsSelected,
        emailTabIsSelected: selected === TIMELINE_FILTER_ENGAGEMENT_TYPES.ENGAGEMENTS_EMAIL,
        objectType: objectType,
        onVisibilityChange: this.handleRefreshQueuesData,
        subjectId: subjectId,
        profileStartTime: this.profileStartTime
      })));
    }
  }]);
  return ProfileTimelineTabsContainer;
}(_PureComponent2.default);

exports.WrappedComponent = ProfileTimelineTabsContainer;
ProfileTimelineTabsContainer.propTypes = propTypes;

var _default = (0, _generalStore.connect)(dependencies)(ProfileTimelineTabsContainer);

exports.default = _default;